module.exports = __webpack_public_path__ + "img/active-list5.708541b8.png";